import { Service } from '@roc/feature-app-core';
import { UnclassifiedDocumentSaveRequest } from '../components/genericDocReview/unclassifiedDocuments/unclassifiedDocumentsTypes';

const url = {
  UNCLASSIFIED_DOCUMENTS: '/api/v1/doc-review/underwriting/unclassifiedDocuments',
  // Same endpoint as feature-documents' DocumentService.getLoanToDos — not imported from there
  // because feature-documents already depends on this lib.
  GET_LOAN_TASKS: '/api/v1/taskV2/getLoanTasks',
};

const UNDERWRITING_LOAN_PROCESS = 'Underwriting';

export class UnclassifiedDocumentsService extends Service {
  getDocuments(loanId: number) {
    return this.get(url.UNCLASSIFIED_DOCUMENTS, { loanId });
  }

  /** Underwriting tasks of the loan, as a { sectionName: tasks[] } map ordered by section. */
  getUnderwritingTasks(loanId: number) {
    return this.get(`${url.GET_LOAN_TASKS}/${loanId}`, {
      loanProcess: UNDERWRITING_LOAN_PROCESS,
      showAllTasks: true,
    });
  }

  save(documentId: number, request: UnclassifiedDocumentSaveRequest) {
    return this.post(`${url.UNCLASSIFIED_DOCUMENTS}/${documentId}/save`, request);
  }

  /** Discards the document: it leaves the list without being uploaded anywhere. */
  discard(documentId: number) {
    return this.post(`${url.UNCLASSIFIED_DOCUMENTS}/${documentId}/discard`, {});
  }

  /** Raw bytes of the stored chat attachment; Content-Type comes back in the response headers. */
  getFile(documentId: number) {
    return this.get(
      `${url.UNCLASSIFIED_DOCUMENTS}/${documentId}/file`,
      {},
      { responseType: 'arraybuffer' }
    );
  }
}
